import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';

function Quadrants() {
  const { octant, galaxy } = useParams();
  const navigate = useNavigate();
  const { api } = useAuth();
  const [quadrants, setQuadrants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [offset, setOffset] = useState(0);
  const [total, setTotal] = useState(0);
  const limit = 50;

  useEffect(() => {
    fetchQuadrants();
  }, [offset]);

  const fetchQuadrants = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/api/universe/quadrants?octant=${octant}&galaxy=${galaxy}&offset=${offset}&limit=${limit}`);
      setQuadrants(response.data.quadrants);
      setTotal(response.data.total);
    } catch (error) {
      console.error('Failed to fetch quadrants:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadMore = () => {
    setOffset(prev => prev + limit);
  };

  return (
    <div className="min-h-screen pb-20">
      <Header
        breadcrumbs={[
          { label: 'ARC Sectors', link: '/explore/octants' },
          { label: `ARC - ${parseInt(octant) + 1}`, link: `/explore/galaxies/${octant}` },
          { label: `Galaxy-${galaxy}` }
        ]}
      />

      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h2 className="text-4xl font-bold mb-2">Quadrants in Galaxy-{galaxy}</h2>
          <p className="text-muted-foreground">Showing {quadrants.length} of {total.toLocaleString()} quadrants</p>
        </div>

        {loading && offset === 0 ? (
          <div className="flex justify-center py-20">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8" data-testid="quadrants-grid">
              {quadrants.map((quadrant) => (
                <button
                  key={quadrant.id}
                  onClick={() => navigate(`/explore/sections/${octant}/${galaxy}/${quadrant.id}`)}
                  className="glass-card rounded-xl p-6 text-left group"
                  data-testid={`quadrant-${quadrant.id}`}
                >
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-xl font-bold text-primary">{quadrant.name}</h3>
                    <svg className="w-5 h-5 text-cyan-400 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                  <p className="text-sm text-muted-foreground">1,000 Sections</p>
                </button>
              ))}
            </div>

            {offset + limit < total && (
              <div className="flex justify-center">
                <button
                  onClick={loadMore}
                  disabled={loading}
                  className="px-6 py-3 bg-cyan-500/90 hover:bg-cyan-400 text-slate-900 font-semibold rounded-lg btn-glow disabled:opacity-50 transition-all"
                  data-testid="load-more"
                >
                  {loading ? 'Loading...' : 'Load More'}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Quadrants;
